jQuery(document).ready(function ($) {
    $('.count').counterUp({
        delay: 5,
        time: 1000
    });
});